import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {bindActionCreators} from "redux";

import {fetchUserArticles, resetUserArticles} from "../../../../creators/user.articles";
import {fetchTagsBlog} from "../../../../creators/tagsBlog";

import Views from '../../../components/Views';
import Answers from '../../../components/Answers';
import pictureLogo from '../../../../images/logo.png';
import {Button} from "../../../components/Button";
import Title from "../../../components/Title";
import {PageLoader} from "../../../components/Loader";
import Pagination from "../../../components/Pagination";
import Modal from "../../../components/Modal";
import {Can} from "../../../../ability-context";
import AdvancedEditorArticle from "../../../components/advanced-editor/AdvancedEditorArticle";
import createLink from "../../../../libs/createLink";
import ContentLoader from "react-content-loader";
import _ from "lodash";
import Icon from "../../../components/Icon";
import Like from "../../../components/Like/Like";
import {Helmet} from "react-helmet";
import {config} from "../../../../config";
import {canonical, isNoFollowArticle} from "../../../../libs/helper";
import CtaCannot from "../../../components/CtaCannot";
import DateSince from "../../../components/Date";


class ProfileArticles extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            limit: 18,
            sort: "-createdAt",
            page: 1
        };
        this.state = {
            toggleEditBlog: false,
            toggleAdvancedEditor: false,
            toggleAlertDeleteBlog: false,
            filter: {...this.filter, page: this.props.match.params.page || 1}
        };
        this.onSubmitForm = this.onSubmitForm.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);

        this.props.fetchUserArticles(this.props.user._id, this.state.filter);
        this.props.fetchTagsBlog({owner : this.props.user._id, kind : "blog"});
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user._id !== this.props.user._id) {
            this.props.fetchUserArticles(this.props.user._id, this.state.filter);
        }
    }

    componentWillUnmount() {
        this.props.resetUserArticles();
    }

    handleDelete() {
        let blog = {...this.props.blog} || {...this.props};
        this.props.removeBlog(blog._id);
        this.setState({toggleAlertDeleteBlog: false});
    }

    handleClose() {
        this.setState({toggleAdvancedEditor: false});
    }

    handleChangePage(page, link) {
        let newFilter = {...this.state.filter, page};
        this.props.fetchUserArticles(this.props.user._id, newFilter);
        this.setState({filter: newFilter, page: page});

        if (page === 1) {
            this.props.history.push(link);
        } else {
            this.props.history.push(link + '/' + page);
        }
        window.scrollTo(0, 0);
    }

    onSubmitForm() {
        this.formBlog.onSubmit();
    }

    render() {
        let totalPage = Math.ceil(this.props.userArticlesTotal / this.state.filter.limit);
        let currentPage = parseInt(this.state.filter.page);
        return !this.props.userArticlesInitialized ? (
            <div className="main-wrapper profil-blog card big">
                <div className="wrapper-profil-articles">
                    <PageLoader/>
                </div>
            </div>
        ) : (
            <div className="main-wrapper profil-blog card big">
                <Helmet>
                    <title>{config.preTitle}Blog Sexe Amateur de {(this.props.user && this.props.user.username) || ""}{config.postTitle} {currentPage >1 ? `( page ${currentPage} )` : ""}</title>
                    {currentPage === 2 && (<link rel="prev" href={canonical(`${createLink("userArticles", {slug : this.props.user.slug})}`, "", "articles")}/>)}
                    {currentPage >= 3 && (<link rel="prev" href={`${canonical(`${createLink("userArticles", {slug : this.props.user.slug})}/${(currentPage - 1)}`, "", "articles")}`} />)}
                    <link rel="canonical" href={currentPage >1 ? `${canonical(`${createLink("userArticles", {slug : this.props.user.slug})}/${currentPage}`, "", "articles")}` : canonical(createLink("userArticles", {slug : this.props.user.slug}), "", "articles")} />
                    {currentPage < totalPage && (<link rel="next" href={`${canonical(`${createLink("userArticles", {slug : this.props.user.slug})}/${(currentPage + 1)}`, "", "articles")}`} />)}
                </Helmet>
                <div className="wrapper-profil-articles">
                    <div className="profil-articles-topline row align-center justify-space-between full mb-8">
                        {this.props.tagBlog.title && (<h1>{this.props.tagBlog.title}</h1>)}
                        {this.props.isMe && (
                            <Can action="create" subject="Article" passThrough>
                                {can => {
                                    return can ? (
                                        <div className="options row align-center ml-auto ">
                                            <Button className="menu-item"
                                                    btnStyle={"primary-reverse"}
                                                    size={"small"}
                                                    content={"Ajouter un billet"}
                                                    onClick={() => this.setState({toggleAdvancedEditor: true})}/>
                                        </div>
                                    ) : (
                                        <div className="options row align-center ml-auto ">
                                            <CtaCannot action={"createArticle"} isModal={true} button={{content : "Ajouter un billet", btnStyle : "primary-reverse", size : "small", className:"menu-item"}} />
                                        </div>
                                    )}}
                            </Can>
                        )}
                        <Modal toggle={this.state.toggleAdvancedEditor} handleClose={this.handleClose}>
                            <AdvancedEditorArticle handleClose={this.handleClose} />
                        </Modal>
                    </div>
                    <div className="profil-articles-content">
                        {this.props.userArticlesLoading ? (
                            _.times(20).map((item, index) => (
                                <div className={"last-articles"} key={index}>
                                    <ContentLoader
                                        height={250}
                                        width={250}
                                        speed={2}
                                        primaryColor="#f3f3f3"
                                        secondaryColor="#ecebeb"
                                    >

                                    </ContentLoader>
                                </div>
                            ))
                        ) : (
                            <Fragment>
                                {this.props.userArticles && this.props.userArticles.length >= 1 && this.props.userArticles.map((item, index) => {
                                    let owner = item.owner;
                                    let link = createLink("article", {...owner,article: item});
                                    let title = item.title || " ";
                                    if (title.length > 55) {
                                        title = title.substring(0, 55) + '...';
                                    }
                                    title = title.charAt(0).toUpperCase() + title.substring(1).toLowerCase();
                                    let relLink = isNoFollowArticle(item) ? { rel: "nofollow" } : {};

                                    return (<div className="last-articles" key={index}>
                                            {(!item.isOpened || item.right === "private" || item.right === "privateclub") &&
                                                <div className={"card-information"}>
                                                    {item.isOpened && item.right === "private" && (
                                                        <Icon type={"user"} />
                                                    )}
                                                    {item.isOpened && item.right === "privateclub" && (
                                                        <Icon type={"group"} />
                                                    )}
                                                    {!item.isOpened && (
                                                        <Icon type={"lock"} />
                                                    )}
                                                </div>
                                            }
                                            {item.cover.length ? (
                                                <div className="article-img"
                                                     style={{backgroundImage: `url(${item.cover})`}}>
                                                    <Link to={{
                                                        pathname: link,
                                                        state: {
                                                            fromProfile: true
                                                        }
                                                    }} {...relLink}></Link></div>
                                            ) : (
                                                <div className="article-img">
                                                    <Link to={{
                                                        pathname: link,
                                                        state: {
                                                            fromProfile: true
                                                        }
                                                    }} {...relLink} className="title-link-articles">
                                                        <img src={pictureLogo}  loading="lazy" alt=""/>
                                                        <span
                                                            className="text medium-grey">Cet article n'a pas d'illustration</span>
                                                    </Link>
                                                </div>
                                            )}
                                            <Link to={{
                                                pathname: link,
                                                state: {
                                                    fromProfile: true
                                                }
                                            }} {...relLink}>
                                                <Title heading={"heading-4"}>{title}</Title>
                                                <div className="date">
                                                    <DateSince
                                                        date={item.publishedAt}
                                                        prefix={'Le'}
                                                        currentFormat={true}
                                                    />
                                                </div>
                                            </Link>
                                            <div className="last-articles-footer">
                                                <Views type="icon"
                                                       value={item.count && (item.count.view || 0)}/>
                                                <Answers value={item.count && (item.count.comment || 0)}/>
                                                <Like
                                                    isLiked={item.isLiked}
                                                    value={item.count && (item.count.like || 0)}
                                                    likeType={"articles"}
                                                    parentId={item._id}
                                                />
                                            </div>
                                        </div>
                                    )
                                })}
                            </Fragment>
                        )}
                        <div className="btn-group">
                            {totalPage > 1 && (
                                <Pagination
                                    currentPage={this.state.filter.page}
                                    pagesCount={totalPage}
                                    handleChangePage={this.handleChangePage}
                                    link={this.props.isMe ? createLink("userMeArticles") : createLink("userArticles", this.props.user)}
                                />
                            )}
                        </div>

                        {this.props.userArticles && this.props.userArticles.length === 0 && (
                            <div className="no-content">Il n'y a aucun article</div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userArticles: state.userArticles.data,
        userArticlesLoading: state.userArticles.loading,
        userArticlesInitialized: state.userArticles.initialized,
        userArticlesTotal: state.userArticles.total,
        tagBlog: state.tagsBlog.data,
    }
};


const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserArticles,
    resetUserArticles,
    fetchTagsBlog
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProfileArticles);
